import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "frame"]

  connect() {
    this.onCancel = (event) => {
      event.preventDefault()
      this.close()
    }
    this.dialogTarget?.addEventListener("cancel", this.onCancel)

    this.onBackdropClick = (event) => {
      if (event.target !== this.dialogTarget) return
      this.close()
    }
    this.dialogTarget?.addEventListener("click", this.onBackdropClick)
  }

  disconnect() {
    this.dialogTarget?.removeEventListener("cancel", this.onCancel)
    this.dialogTarget?.removeEventListener("click", this.onBackdropClick)
  }

  open(event) {
    event.preventDefault()
    const url = event.currentTarget?.getAttribute("href")
    if (!url) return

    const withCacheBuster = this.#withCacheBuster(url)
    this.frameTarget.src = withCacheBuster
    this.dialogTarget.showModal()
  }

  close() {
    this.dialogTarget.close()
    this.#resetFrame()
  }

  #withCacheBuster(url) {
    try {
      const u = new URL(url, window.location.origin)
      u.searchParams.set("_ts", Date.now().toString())
      return u.toString()
    } catch {
      const sep = url.includes("?") ? "&" : "?"
      return `${url}${sep}_ts=${Date.now()}`
    }
  }

  #resetFrame() {
    if (!this.hasFrameTarget) return
    this.frameTarget.removeAttribute("src")
    this.frameTarget.innerHTML = `
      <div style="background:#fff;border:1px solid rgba(148,163,184,0.28);padding:18px;border-radius:16px">
        <p style="margin:0;font-size:13px;color:rgba(15,23,42,0.55)">Chargement…</p>
      </div>
    `
  }
}

